<template>
  <div class="questionnaire-detail full-page">
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <div class="page-content">
        <DetailInfo
          :title="title"
          :description="description"
          :endTime="endTime"
        />
        <div class="check-box">
          <template v-if="questionnaireSlave">
            <div
              class="question-item"
              v-for="(question, index) in questionnaireSlave"
              :key="question.Id"
            >
              <div class="question-title van-hairline--bottom">
                {{ index + 1 }}、{{ question.questionTitle
                }}<span class="optional">{{
                  question.required === false ? "（选填）" : ""
                }}</span>
              </div>

              <!-- 单选 -->
              <van-radio-group
                v-if="question.questionType === 0"
                v-model="result[index].slaveValue"
              >
                <van-radio
                  class="select-radio van-hairline--bottom"
                  v-for="option in question.options"
                  :key="option.optionId"
                  :name="option.optionId"
                >
                  {{ option.option }}
                  <template #icon="props">
                    <img
                      class="img-check"
                      :src="
                        isEnd || choiceStatus
                          ? radioInactiveIcon
                          : props.checked
                          ? radioActiveIcon
                          : radioInactiveIcon
                      "
                    />
                  </template>
                </van-radio>
              </van-radio-group>

              <!-- 多选 -->
              <van-checkbox-group
                v-if="question.questionType === 1"
                v-model="result[index].slaveValue"
              >
                <van-checkbox
                  class="select-checkbox van-hairline--bottom"
                  v-for="option in question.options"
                  :key="option.optionId"
                  :name="option.optionId"
                >
                  {{ option.option }}
                  <template #icon="props">
                    <img
                      class="img-check"
                      :src="
                        isEnd || choiceStatus
                          ? checkboxInactiveIcon
                          : props.checked
                          ? checkboxActiveIcon
                          : checkboxInactiveIcon
                      "
                    />
                  </template>
                </van-checkbox>
              </van-checkbox-group>

              <!-- 填空 -->
              <van-cell-group v-if="question.questionType === 2">
                <van-field
                  :disabled="isEnd || choiceStatus"
                  type="textarea"
                  placeholder="请输入"
                  v-model="result[index].slaveValue"
                />
              </van-cell-group>
            </div>
          </template>
        </div>
      </div>
    </van-pull-refresh>
    <div class="submit-box">
      <van-button
        @click="submit"
        type="primary"
        block
        :disabled="submitDisabled"
        >{{ submitText }}</van-button
      >
    </div>
  </div>
</template>
<script>
import {
  questionnaireDetailAPI,
  questionnaireSubmitAPI,
} from "@/api/questionnaire";
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { checkResponse, isTimeEnd } from "@/assets/js/utils";
import DetailInfo from "@/components/DetailInfo";
import { Checkbox, CheckboxGroup, RadioGroup, Radio } from "vant";
export default {
  name: "QuestionnaireDetail",
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    DetailInfo,
  },
  data() {
    return {
      checkboxActiveIcon: require("@/assets/images/checkbox_active.png"),
      checkboxInactiveIcon: require("@/assets/images/checkbox_inactive.png"),
      radioActiveIcon: require("@/assets/images/radio_active.png"),
      radioInactiveIcon: require("@/assets/images/radio_inactive.png"),
      detailId: 0,
      isRefresh: false,
      title: "",
      description: "",
      endTime: undefined,
      questionnaireSlave: null,
      choiceStatus: false,
      result: null,
    };
  },
  computed: {
    isEnd() {
      let isEnd = false;
      if (this.endTime !== undefined && this.endTime != null) {
        isEnd = isTimeEnd(this.endTime);
      }
      return isEnd;
    },
    submitDisabled() {
      let disabled = true;
      if (this.choiceStatus) {
        // 已投票
        disabled = true;
      } else if (this.isEnd) {
        // 已结束
        disabled = true;
      } else {
        disabled = false;
      }
      return disabled;
    },
    submitText() {
      let text = "";
      if (this.choiceStatus) {
        text = "已提交";
      } else if (this.isEnd) {
        text = "已结束";
      } else {
        text = "提交";
      }
      return text;
    },
  },
  mounted() {
    BridgeNativeMethods.setTitle("问卷调查");

    this.detailId = parseInt(this.$route.params.id);
    this.requestData();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      questionnaireDetailAPI(this.detailId).then(
        (response) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
            let { title, describe, endTime, questionnaireSlave, choiceStatus } =
              response.data;
            this.title = title;
            this.description = describe;
            this.endTime = endTime;
            this.initResult(questionnaireSlave);
            this.questionnaireSlave = questionnaireSlave;
            this.choiceStatus = choiceStatus;
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log("activity detail err", err);
        }
      );
    },
    onRefresh() {
      this.isRefresh = true;
      this.requestData();
    },
    initResult(questionnaireSlave) {
      if (questionnaireSlave != null) {
        this.result = questionnaireSlave.map((question) => {
          return {
            slaveId: question.Id,
            slaveValue: question.questionType === 1 ? [] : null,
          };
        });
      }
    },
    checkboxToggle(index, option) {
      console.log("check", index, option);
    },
    radioChange(value, index, option) {
      console.log("radio", value, index, option);
    },
    inputChange(value, index, option) {
      console.log("input", value, index, option);
    },
    submit() {
      console.log("submit", this.result);
      let valid = false;
      if (this.result) {
        valid = true;
        for (let i = 0; i < this.result.length; i++) {
          let question = this.questionnaireSlave[i];
          let questionValue = this.result[i].slaveValue;
          if(valid === false) break;
          if (question.required) {
            if (question.questionType === 0) {
              // 单选
              if (questionValue === null) {
                valid = false;
                BridgeNativeMethods.showToast(
                  "请选择" + question.questionTitle
                );
              }
            } else if (question.questionType === 1) {
              // 多选
              if (questionValue === null || questionValue.length === 0) {
                valid = false;
                BridgeNativeMethods.showToast(
                  "请选择" + question.questionTitle
                );
              }
            } else if (question.questionType === 2) {
              if (questionValue === null || questionValue === "") {
                valid = false;
                BridgeNativeMethods.showToast(
                  "请填写" + question.questionTitle
                );
              }
            }
          }
        }
      }

      if (valid) {
        // 值转成字符串
        let submitResult = this.result.map(({slaveId,slaveValue},index) => {
          return {
            slaveId,
            slaveValue:  this.questionnaireSlave[index].questionType ===1 ? slaveValue.join(",") : (slaveValue==null?'':slaveValue.toString())
          }
        })
        BridgeNativeMethods.showLoading();
        questionnaireSubmitAPI({
          questionnaireId: this.detailId,
          slaves: submitResult,
        }).then(
          (response) => {
            if (checkResponse(response)) {
              console.log(response.data);
               // 跳转结果
              BridgeNativeMethods.navigateQuestionnaireResult({
                id:response.data
              })
            } else {
              BridgeNativeMethods.showToast(response.message);
            }
          },
          (err) => {
            BridgeNativeMethods.hideLoading();
            BridgeNativeMethods.showToast("请求错误");
            console.log("activity detail err", err);
          }
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  min-height: 100vh;
  margin-bottom: 65px;
}

.submit-box {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 8px;
  z-index: 10;
  background: #ffffff;
}
.question-item {
  margin-top: 16px;
  background-color: #fff;
}
.question-title {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 48px;
  padding-left: 16px;

  &.van-hairline--bottom::after {
    left: -44%;
  }
}
.optional {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.select-radio {
  padding-left: 16px;
  height: 48px;

  &.van-hairline--bottom::after {
    left: -32%;
  }
}
.select-checkbox {
  padding-left: 16px;
  height: 48px;

  &.van-hairline--bottom::after {
    left: -32%;
  }
}

/deep/.van-checkbox__label {
  margin-left: 16px;
}
/deep/.van-cell::after {
  left: 62px;
  right: 0;
}
/deep/.van-checkbox__icon,
/deep/.van-radio__icon {
  height: 24px;
  line-height: 24px;
}
/deep/.van-button--disabled {
  background-color: #d8d8d8;
  opacity: 1;
  border-color: #d8d8d8;
}
/deep/.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  left: -44%;
}
.img-check {
  width: 24px;
  height: 24px;
}
</style>